<template>
  <div>
    <el-radio-group v-model="value" @change="changeAMPM">
      <el-radio :disabled="disabled" :label="1">上午</el-radio>
      <el-radio :disabled="disabled" :label="2">下午</el-radio>
      <el-tooltip placement="top-start" effect="light">
        <div slot="content">
          <p>收货时间可选时间段</p>
          <p>上午：6：00 - 11：00</p>
          <p>下午：13：00 - 20：00</p>
        </div>
        <el-button circle icon="el-icon-question"></el-button>
      </el-tooltip>
    </el-radio-group>
    <br />
    <el-time-select
      :disabled="disabled"
      style="margin-right:10px;margin-top: 15px;width:150px"
      placeholder="起始时间"
      @change="changeStart"
      v-model="formData.receiveStartTime"
      :picker-options="{start: startTimeStart, step: '00:30', end: startTimeEnd}"
    />-
    <el-time-select
      :disabled="disabled"
      style="margin-left:10px;width:150px"
      placeholder="结束时间"
      @change="changeEnd"
      v-model="formData.receiveEndTime"
      :picker-options="{start: endTimeStart, step: '00:30', end: endTimeEnd, minTime: startTime }"
    />
  </div>
</template>

<script>
const morning = {
  startTimeStart: "06:00",
  startTimeEnd: "10:00",
  endTimeStart: "07:00",
  endTimeEnd: "11:00"
};
const afternoon = {
  startTimeStart: "13:00",
  startTimeEnd: "19:00",
  endTimeStart: "14:00",
  endTimeEnd: "20:00"
};

export default {
  name: "get-goods-time",
  props: {
    receiveStartTime: String,
    receiveEndTime: String,
    text: Array,
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      value: 1,
      formData: {
        receiveStartTime: this.receiveStartTime,
        receiveEndTime: this.receiveEndTime
      },
      startTime: "",
      ...morning
    };
  },
  watch: {
    text: {
      immediate: true,
      handler: async function(val) {
        var _this = this;
        if (val && val.length !== 0) {
          const [receiveStartTime, receiveEndTime] = val;
          if (+receiveStartTime.split(":")[0] > 10) {
            _this.value = 2;
            this.changeAMPM(2);
          }
          _this.formData.receiveStartTime = receiveStartTime;
          this.changeStart(receiveStartTime);
          _this.formData.receiveEndTime = receiveEndTime;
        }
      }
    }
  },
  methods: {
    timeAddHalfHour(val) {
      let [hour, min] = val.split(":");
      hour = +hour;
      min = +min + 30;
      if (min === 60) {
        hour += 1;
        min = "00";
      } else {
        min = "30";
      }
      hour = hour > 10 ? hour.toString() : "0" + hour.toString();
      return [hour, min].join(":");
    },
    changeAMPM(val) {
      this.formData = {
        receiveEndTime: "",
        receiveStartTime: ""
      };
      if (val === 1) {
        Object.assign(this, morning);
      } else {
        Object.assign(this, afternoon);
      }
    },
    changeStart(val) {
      if (val) {
        this.startTime = this.timeAddHalfHour(val);
        this.formData.receiveEndTime = "";
        this.$emit('update:receiveStartTime', val)
        return;
      }
      this.formData.receiveStartTime = "";
      this.formData.receiveEndTime = "";
      this.$emit('update:receiveStartTime', "")

    },
    changeEnd(val) {
      if (val && this.formData.receiveStartTime === "") {
        this.formData.receiveEndTime = "";
        this.$emit("update:receiveEndTime", "");
        return;
      } else if (!val) {
        this.formData.receiveEndTime = "";
      }
      this.$emit("update:receiveEndTime", val);
    }
  }
};
</script>
